import { render, staticRenderFns } from "./screenForm.vue?vue&type=template&id=5a90b526&scoped=true"
import script from "./screenForm.vue?vue&type=script&lang=js"
export * from "./screenForm.vue?vue&type=script&lang=js"
import style0 from "./screenForm.vue?vue&type=style&index=0&id=5a90b526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90b526",
  null
  
)

export default component.exports